
<template>
  <section class="layout-pt-lg layout-pb-lg" :style="`background-color: var(--c-${vars.backgroundColor})`">
    <div class="container">
      <div class="row justify-center text-center">
        
        <div class="col-12 flex flex-col items-center">
  <svg
    class="block mb-4 mx-auto"
    width="58"
    height="58"
    viewBox="0 0 58 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    
    <path d="M16.224 9.59106C17.327 11.5261 18.102 13.4411 18.551 15.3411C18.999 17.2411 19.224 19.1581 19.224 21.0911C19.224 23.3581 18.927 25.5911 18.336 27.7911C17.746 29.9911 16.945 32.1251 15.936 34.1911C14.927 36.2571 13.756 38.2241 12.423 40.0891C11.089 41.9561 9.68905 43.7241 8.22305 45.3901L7.82305 44.9901C7.68805 44.8571 7.62305 44.6911 7.62305 44.4901C7.62305 44.4261 7.68805 44.2581 7.82305 43.9901C10.756 39.9901 12.989 36.2911 14.523 32.8901C16.056 29.4901 16.823 26.1241 16.823 22.7901C16.823 20.6571 16.589 18.8401 16.123 17.3401C15.656 15.8401 14.956 14.1901 14.023 12.3901C13.756 11.8571 13.623 11.5251 13.623 11.3901C13.623 11.0571 13.823 10.7901 14.223 10.5901L16.224 9.59106ZM40.123 9.59106C41.227 11.5261 42.002 13.4411 42.45 15.3411C42.898 17.2411 43.123 19.1581 43.123 21.0911C43.123 23.3581 42.84 25.5911 42.273 27.7911C41.707 29.9911 40.923 32.1251 39.923 34.1911C38.923 36.2571 37.755 38.2241 36.423 40.0891C35.089 41.9561 33.689 43.7241 32.223 45.3901L31.824 44.9901C31.689 44.8571 31.623 44.6911 31.623 44.4901C31.623 44.4261 31.689 44.2581 31.824 43.9901C34.723 39.9901 36.933 36.2911 38.449 32.8901C39.965 29.4901 40.723 26.1241 40.723 22.7901C40.723 20.6571 40.489 18.8401 40.023 17.3401C39.556 15.8401 38.856 14.1901 37.923 12.3901C37.655 11.8571 37.523 11.5251 37.523 11.3901C37.523 11.0571 37.723 10.7901 38.123 10.5901L40.123 9.59106Z" fill="#BFA87E"/>
    <g opacity="0.4">
      <path d="M22.1362 14.218C23.2392 16.153 24.0142 18.068 24.4632 19.968C24.9112 21.868 25.1362 23.785 25.1362 25.718C25.1362 27.985 24.8392 30.218 24.2482 32.418C23.6582 34.617 22.8572 36.752 21.8482 38.818C20.8392 40.884 19.6682 42.851 18.3352 44.718C17.0012 46.585 15.6012 48.351 14.1352 50.017L13.7352 49.617C13.6002 49.484 13.5352 49.318 13.5352 49.117C13.5352 49.053 13.6002 48.885 13.7352 48.617C16.6682 44.617 18.9012 40.918 20.4352 37.517C21.9682 34.117 22.7352 30.751 22.7352 27.418C22.7352 25.285 22.5012 23.468 22.0352 21.968C21.5682 20.468 20.8682 18.818 19.9352 17.018C19.6682 16.485 19.5352 16.153 19.5352 16.018C19.5352 15.685 19.7352 15.418 20.1352 15.218L22.1362 14.218ZM46.0362 14.218C47.1392 16.153 47.9132 18.068 48.3622 19.968C48.8102 21.868 49.0362 23.785 49.0362 25.718C49.0362 27.985 48.7512 30.218 48.1852 32.418C47.6182 34.617 46.8342 36.752 45.8342 38.818C44.8342 40.884 43.6682 42.851 42.3342 44.718C41.0002 46.585 39.6002 48.351 38.1352 50.017L37.7352 49.617C37.6002 49.484 37.5362 49.318 37.5362 49.117C37.5362 49.053 37.6002 48.885 37.7352 48.617C40.6352 44.617 42.8442 40.918 44.3602 37.517C45.8762 34.116 46.6352 30.751 46.6352 27.418C46.6352 25.285 46.4012 23.468 45.9352 21.968C45.4672 20.468 44.7682 18.818 43.8342 17.018C43.5672 16.485 43.4352 16.153 43.4352 16.018C43.4352 15.685 43.6352 15.418 44.0362 15.218L46.0362 14.218Z" fill="#BFA87E"/>
    </g>
  </svg>
  <h2>{{ vars.titleText }}</h2>
</div>

        
        <div class="col-xl-8 col-lg-9 col-md-10">
          <div
            class="overflow-hidden js-section-slider"
            data-gap="30"
            data-slider-cols="xl-1 lg-1 md-1 sm-1 base-1"
            data-pagination="js-pagination"
            data-custom-pagination="true"
          >
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="review in reviews" :key="review._id">
                <!-- ... -->
              </div>
            </div>
            <div class="testimonialsNav mt-60 md:mt-30">
              <!-- ... -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'Theme8GoogleReview',

  mixins: [ComponentMixin],

  data() {
    return {
      reviews: null,
    };
  },

  created() {
    const parsedReviews = this.parseFormV2(this.vars.googleReviews);
    this.reviews = parsedReviews?.reviews?.filter((review: any) => review.content?.trim());
  },
});
</script>

<style scoped>
.testimonials__text::-webkit-scrollbar {
  width: 4px;
  background-color: transparent;
}

.testimonials__text::-webkit-scrollbar-thumb {
  background-color: var(--c-primary);
  border-radius: 4px;
  opacity: 0.7;
}

.testimonials__text::-webkit-scrollbar-track {
  background-color: transparent;
}
</style>
